import { useContext } from "react";
import { AuthContext } from "../../context/auth";

/**
 * Persistent strip shown whenever the logged-in user's organization is in
 * sandbox mode. Renders null otherwise, so it is a free render for normal
 * tenant traffic. Admin users have no tenant-scoped organization, so this
 * never shows in the super-admin portal.
 */
const SandboxBanner: React.FC = () => {
    const { authState } = useContext(AuthContext);
    const isSandbox =
        authState?.user?.relationships?.organization?.attributes?.is_sandbox;

    if (!isSandbox) {
        return null;
    }

    return (
        <div
            data-testid="sandbox-banner"
            className="bg-warning text-warning-content w-full py-2 px-4 flex items-center justify-center"
        >
            <div className="font-semibold text-sm">
                This organization is in sandbox mode.
            </div>
        </div>
    );
};

export default SandboxBanner;
